import { PropsWithChildren } from 'react';

export const TeamsProtectedRoute = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};
